import { TicketBookingFlow } from '_organisms';
import React from 'react';

const Tickets: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-4 md:mb-8">
        <h1 className="text-lg md:text-3xl font-bold text-gray-900 mb-2">
          Book Your Skating Session
        </h1>
      </div>
      <TicketBookingFlow />
    </div>
  );
};

export default Tickets;
